import { ExpansionCard } from '@navikt/ds-react/ExpansionCard'
// The library's own styling, and only the parts this component needs. ⛔ THE
// GLOBAL SHEETS ARE DELIBERATELY LEFT OUT — `reset.css` and `baseline.css`
// restyle `html` and `body` for the whole portal.
import '@navikt/ds-css/dist/global/tokens.css'
import '@navikt/ds-css/dist/component/typography.css'
import '@navikt/ds-css/dist/component/expansioncard.css'
import './SectionCard.css'
import type { SectionCardProps } from './SectionCard.types'

/** Collapsible section. Mobile headings and summaries wrap; desktop keeps one row. */
export function SectionCard({ label, summary, defaultOpen = false, children }: SectionCardProps) {
  return (
    <ExpansionCard
      /* The library needs a name for the region and will not infer one from
         the title it renders. The label is that name. */
      aria-label={label}
      /* SMALL IS THE ONLY HONEST SIZE HERE. At medium the chevron alone is 48px
         and the header clears 80px — four of those stack past the fold of the
         popup they live in. Small brings it to 56px. */
      size="small"
      defaultOpen={defaultOpen}
    >
      <ExpansionCard.Header>
        {/* ONE ROW, LABEL LEFT AND SUMMARY RIGHT. `grow` is what makes the
            summary reach the trailing edge: without it this div shrinks to its
            content and the summary sits against the label instead of across
            from it. */}
        <span className="section-card-heading flex grow items-center justify-between gap-3">
          <ExpansionCard.Title size="small">{label}</ExpansionCard.Title>
          {/* The mobile stylesheet gives the summary its own readable line. */}
          {summary === undefined ? null : (
            <span className="section-card-summary flex min-w-0 shrink items-center truncate">{summary}</span>
          )}
        </span>
      </ExpansionCard.Header>
      <ExpansionCard.Content>{children}</ExpansionCard.Content>
    </ExpansionCard>
  )
}
